import { Box, IconButton, Typography } from '@mui/material';
import { usePickerTranslations } from '@mui/x-date-pickers/hooks';
import { ArrowLeftIcon, ArrowRightIcon } from '@mui/x-date-pickers/icons';
import type { PickersRangeCalendarHeaderProps } from '@mui/x-date-pickers-pro';
import { addMonths, format, isAfter, isBefore, startOfMonth } from 'date-fns';
import React from 'react';

export const RangeCalendarHeader5 = React.forwardRef<
  HTMLDivElement,
  PickersRangeCalendarHeaderProps
>(function RangeCalendarHeader5(
  {
    currentMonth,
    onMonthChange,
    disablePast,
    disableFuture,
    minDate,
    maxDate,
    labelId,
  },
  ref
) {
  const translations = usePickerTranslations();
  const now = new Date();
  const firstMonth = startOfMonth(
    disablePast && isAfter(now, minDate) ? now : minDate
  );
  const lastMonth = startOfMonth(
    disableFuture && isBefore(now, maxDate) ? now : maxDate
  );
  return (
    <Box
      ref={ref}
      sx={{
        padding: '16px 16px 8px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <IconButton
        size="small"
        edge="end"
        aria-label={translations.previousMonth}
        title={translations.previousMonth}
        disabled={!isBefore(firstMonth, currentMonth)}
        onClick={() => onMonthChange(addMonths(currentMonth, -1))}
      >
        <ArrowLeftIcon />
      </IconButton>
      <Typography variant="subtitle1" component="span" id={labelId}>
        {format(currentMonth, 'MMMM yyyy')}
      </Typography>
      <IconButton
        size="small"
        edge="start"
        aria-label={translations.nextMonth}
        title={translations.nextMonth}
        disabled={!isAfter(lastMonth, currentMonth)}
        onClick={() => onMonthChange(addMonths(currentMonth, 1))}
      >
        <ArrowRightIcon />
      </IconButton>
    </Box>
  );
});
